import API from '@/amplify/api';
import { selector } from 'recoil';
import {
    getActiveB2BCustomerProjectListOfProject,
    getActiveB2BHelpdeskProjectListOfProject,
} from '@/service/projectService';
import { projectInuseDetailAtom } from '../atom/projectAtom';

export const getListActiveB2BCustomerSelector = selector({
    key: 'getListActiveB2BCustomerSelector',
    get: async ({ get }) => {
        try {
            let projectInuse = get(projectInuseDetailAtom);

            let listB2BCustomer = await getActiveB2BCustomerProjectListOfProject(
                API,
                projectInuse.id,
                true
            );
            return listB2BCustomer;
        } catch (err) {
            console.error(`getProjectListInCorporationByUserId error: ${err}`);
            return [];
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});

export const getListActiveB2BHelpdeskSelector = selector({
    key: 'getListActiveB2BHelpdeskSelector',
    get: async ({ get }) => {
        try {
            let projectInuse = get(projectInuseDetailAtom);

            let listB2BCustomer = await getActiveB2BHelpdeskProjectListOfProject(
                API,
                projectInuse.id,
                true
            );
            return listB2BCustomer;
        } catch (err) {
            console.error(`getProjectListInCorporationByUserId error: ${err}`);
            return [];
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});
